module.exports = __webpack_public_path__ + "static/media/store-error.ab9398b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store-error.svg
// module id = 345
// module chunks = 21